import { Card, CardContent, CardHeader, CardTitle } from '@repo/ui';

interface MetricCardProps {
  title: string;
  value: string | number;
  change24h?: number;
  subtitle?: string;
}

export function MetricCard({ title, value, change24h, subtitle }: MetricCardProps) {
  const hasChange = typeof change24h === 'number';
  const isPositive = hasChange && change24h > 0;
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm font-medium text-gray-600 dark:text-gray-400">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-3xl font-bold text-gray-900 dark:text-white">{value}</div>
        
        {hasChange && (
          <div className="mt-2 flex items-center gap-1">
            <span className={isPositive ? "text-green-600 dark:text-green-400" : "text-red-600 dark:text-red-400"}>
              {isPositive ? "↑" : "↓"} {Math.abs(change24h).toFixed(1)}%
            </span>
            <span className="text-gray-500 dark:text-gray-400 text-sm">vs yesterday</span>
          </div>
        )}
        
        {subtitle && (
          <div className="mt-1 text-sm text-gray-500 dark:text-gray-400">{subtitle}</div>
        )}
      </CardContent>
    </Card>
  );
}
